module.exports = __webpack_public_path__ + "img/appstore.aedfb4bb.png";